import {
    db,
    collection,
    getDocs,
    addDoc,
    doc,
    deleteDoc,
    query,
    where,
    updateDoc,
    onSnapshot,
  } from "@/repository/dataBase";
  const COLLECTION_NAME = "feedback";

  export default{

    getCollectionRef(){
        return collection(db,COLLECTION_NAME)
    },

    subscribeToCollection(collectionRef,callback){
        return onSnapshot(collectionRef,callback)
    },

    async save(feedbackData){
        console.log(feedbackData)
        try {
            await addDoc(collection(db,COLLECTION_NAME),feedbackData);

        } catch (error) {
            console.log(error)
        }
    },
    async getAll(){
        try {
            return new Promise((resolve,reject) => {
                const unsubscribe = onSnapshot(
                    collection(db,COLLECTION_NAME),
                    (snapshot) =>{
                        const feedbacks = snapshot.docs.map((doc) =>{
                            let feedbackData = doc.data();
                            feedbackData.id = doc.id;
                            return feedbackData;
                        });
                        resolve({unsubscribe,feedbacks});
                    },
                    (error)=>{
                        console.log(error);
                        reject(error);
                    }
                )
            })
        } catch (error) {
            console.log(error);
            return{unsubscribe:null,feedbacks:[]};
        }

    }
  }

